import { Link } from 'react-router';
import {
  Building2,
  Zap,
  MessageSquare,
  GitBranch,
  Search,
  Calendar,
} from 'lucide-react';

const cards = [
  {
    icon: Building2,
    title: 'Speziell für Vergabestellen entwickelt',
    description:
      'Unsere Software ist gezielt auf die Anforderungen im öffentlichen Vergabewesen zugeschnitten.',
  },
  {
    icon: Search,
    title: 'KI-gestützte Dokumentenanalyse',
    description:
      'Laden Sie Ihre Vergabedokumente hoch und erhalten Sie innerhalb von Minuten einen strukturierten Qualitätsbericht.',
  },
  {
    icon: Zap,
    title: 'Schnelle Einrichtung',
    description:
      'Kein langwieriges IT-Projekt. stapel.ai ist webbasiert und in wenigen Schritten einsatzbereit.',
  },
  {
    icon: MessageSquare,
    title: 'Direkter Draht zu uns',
    description:
      'Als Early-Access-Partner arbeiten Sie direkt mit unserem Gründerteam.',
  },
  {
    icon: GitBranch,
    title: 'Ihr Feedback formt das Produkt',
    description:
      'Ihre Anforderungen und Ihr Feedback fließen direkt in die Weiterentwicklung ein.',
  },
  {
    icon: Calendar,
    title: 'Erleben Sie die Plattform',
    description: '',
    cta: true,
  },
];

export function FeatureCards() {
  return (
    <section className="flex flex-col items-center justify-center w-full relative py-16">
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-secondary via-background to-background" />
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card) => {
            const Icon = card.icon;
            return (
              <div
                key={card.title}
                className="flex flex-col gap-4 p-6 rounded-lg border transition-colors bg-card/50"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10 text-primary">
                    <Icon className="h-6 w-6" />
                  </div>
                </div>
                <div className="prose max-w-none">
                  <h3 className="font-semibold text-[#111]">{card.title}</h3>
                  {card.cta ? (
                    <Link to="/demo">
                      <button className="inline-flex shrink-0 items-center justify-center rounded-lg border border-transparent text-sm font-medium whitespace-nowrap transition-all outline-none select-none active:translate-y-px bg-primary text-primary-foreground h-8 gap-1.5 px-2.5 mt-2 hover:cursor-pointer hover:bg-primary/90">
                        Demo anfragen
                      </button>
                    </Link>
                  ) : (
                    <p className="text-muted-foreground">{card.description}</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
